<template>
  <v-dialog 
    :value="isOpen"
    persistent
    scrollable
    v-if="isOpen"
    content-class="add-edit-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span>{{modalTitle}}</span>
        <v-spacer/>
        <close-button @click="closeModal"/>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" @submit.prevent="submit">
          <h2 class="add-edit-modal-header">Exam Information</h2>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex md4>
                <div>
                  <label class="modal-label">Exam Date*</label>
                </div>
                <date-menu
                  :value="examToEdit.dateIso"
                  @change="setExamDate"
                  name="formattedDate"
                  v-validate="'required|date|inPast'"
                  data-vv-as="Exam Date"
                  :disabled="diableExamDateChange"
                  :error-messages="errors.collect('formattedDate')"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Exam Eye</label>
                </div>
                <select-with-auto-complete-field
                  :value="examToEdit.exEye"
                  @change="setExamEye"
                  name="examToEdit.exEye"
                  :items="eyes"
                  :disabled="true"
                  data-vv-as="Exam Eye"
                  :error-messages="errors.collect('examToEdit.exEye')"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Exam Type</label>
                </div>
                <select-with-auto-complete-field
                  v-model="examToEdit.devSrNo"
                  name="examToEdit.devSrNo"
                  :items="devices"
                  item-value="devSrNo"
                  item-text="procedure"
                  :disabled="true"
                  data-vv-as="Exam Type"
                  :error-messages="errors.collect('examToEdit.devSrNo')"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Attending Physician</label>
                </div>
                <select-with-button 
                  multiple
                  collapsed-when-multiple
                  :value="examToEdit.exAttdMD"
                  :items="physicians"
                  @change="setAttendingPhysician"
                  item-value="phySrNo"
                  item-text="name"
                  item-name="Attending Physician"
                  name="Attending Physician"
                  label="Attending Physician"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Referring Physician</label>
                </div>
                <select-with-button 
                  multiple
                  collapsed-when-multiple
                  :value="examToEdit.exRefMD"
                  :items="physicians"
                  @change="setReferingPhysician"
                  item-value="phySrNo"
                  item-text="name"
                  item-name="Referring Physician"
                  name="Refering Physician"
                  label="Refering Physician"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Dictated</label>
                </div>
                <select-with-auto-complete-field
                  v-model="examToEdit.exDict"
                  :items="yesNo"
                  item-value="value"
                  item-text="text"
                  name="examToEdit.exDict"
                  :error-messages="errors.collect('examToEdit.exDict')"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Teaching/Research Case</label>
                </div>
                <select-with-auto-complete-field
                  v-model="examToEdit.exIsStudy"
                  :items="yesNo"
                  item-value="value"
                  item-text="text"
                  name="examToEdit.exIsStudy"
                  :error-messages="errors.collect('examToEdit.exIsStudy')"/>
              </v-flex><br/>
              <v-flex md10>
                <div>
                  <label class="modal-label">Primary DX</label>
                </div>
                <v-text-field
                  solo
                  v-model="examToEdit.exDxPrimary"
                  name="examToEdit.exDxPrimary"
                  v-validate="'max:256'"
                  data-vv-as="Exam Primary DX"
                  :error-messages="errors.collect('examToEdit.exDxPrimary')"/>
              </v-flex>
              <v-flex md10>
                <div>
                  <label class="modal-label">Secondary DX</label>
                </div>
                <v-text-field
                  solo
                  v-model="examToEdit.exDXSecondary"
                  name="examToEdit.exDXSecondary"
                  v-validate="'max:256'"
                  data-vv-as="Exam Secondary DX"
                  :error-messages="errors.collect('examToEdit.exDXSecondary')"/>
              </v-flex>
              <v-flex md10>
                <div>
                  <label class="modal-label">Pathology</label>
                </div>
                <v-text-field
                  solo
                  v-model="examToEdit.exPathology"
                  name="examToEdit.exPathology"
                  v-validate="'max:256'"
                  data-vv-as="Exam Pathology"
                  :error-messages="errors.collect('examToEdit.exPathology')"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text
          @click="submit"
          class="modal-cta">
          Update
          <v-avatar size="20" class="ml-2">
            <img :src="require('../../assets/' + coloredAssetUrls.submit)">
          </v-avatar>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EYES } from "../../config/config";
import dateMenu from "../controls/DateMenu";
import selectWithAutoCompleteField from "../controls/SelectWithAutoCompleteField";
import selectWithButton from "../controls/SelectWithButton";
import closeButton from "../controls/CloseButton";
import { mapGetters } from "vuex";

export default {
  name: "editExamDialog",
  components: {
    dateMenu,
    selectWithAutoCompleteField,
    closeButton,
    selectWithButton
  },
  data() {
    return {
      eyes: EYES,
      yesNo: [{ value: true, text: "Yes"}, { value: false, text: "No"}],
      valid: false
    };
  },
  computed: {
    ...mapGetters([
      "examToEdit",
      "siteInfo",
      "userIsAdmin",
      "userIsPhotographer"
    ]),
    physicians() {
       let activePhysicians = [...this.$store.getters.physicians].filter(e => {
          return e.phyStatus == 1;
      });
      return activePhysicians.sort((a, b) => a.lastName.localeCompare(b.lastName));
    },
    devices() {
      return this.$store.getters.devices;
    },
    modalTitle() {
      return "Edit Exam";
    },
    isOpen() {
      return !!this.examToEdit;
    },
    diableExamDateChange(){
      return !this.siteInfo.enableExamDateChange || (!this.userIsAdmin && !this.userIsPhotographer);
    }
  },
  methods: {
    submit() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (!valid) return Promise.reject("Please fix all form errors");

          this.$store.dispatch("submitEditExam");
        })
        .catch(msg => {
          this.$store.commit("displayStatus", { message: msg, level: "error" });
        })
        .finally(() => {
          this.closeModal();
        });
    },
    closeModal() {
      this.$store.commit("clearEditExam");
      this.errors.clear();
    },
    setExamEye(value){
      this.$set(this.examToEdit, "exEye", value);
    },
    setExamDate(value){
      this.$set(this.examToEdit, "dateIso", value);
    },
    setAttendingPhysician(value) {
      this.$set(this.examToEdit, "exAttdMD", value);
    },
    setReferingPhysician(value) {
      this.$set(this.examToEdit, "exRefMD", value);
    }
  }
}
</script>